import React from "react";
import { Tabs, Tab, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ChevronLeft';
// toolbar moved into Folders; no TextField/Add/Search here
import Folders from './configuration/Folders';
import Fields from './configuration/Fields';
import Categories from './configuration/Categories';
import { makeStyles } from '@material-ui/core/styles';

import { useHistory } from "react-router-dom";


const useStyles = makeStyles(theme => ({
  root: {
    width: 'calc(100% + 48px)',
    minHeight: 'calc(100% + 48px)',
    overflow: 'auto',
    padding: '32px 24px 24px 24px',
    margin: '-24px',
    backgroundColor: '#F5F3F5'
  },
  grid: {
    display: 'flex',
    overflow: 'auto'
  },

  tabContainer: {
    display: 'flex',
    alignItems: 'center',
    
    padding: 2,
    mb: 2 
  },

  backButton:{
    paddingTop: '8px',
    padding: 0,
    minWidth: 'auto',
    fontSize: '0.8rem',
    textTransform: 'none',
    fontFamily: '"Montserrat", sans-serif !important',
    marginBottom: '7px'
  },

  title:{
    fontFamily: '"Montserrat", sans-serif !important',
    textTransform: 'none',
    fontWeight: '700',
    fontSize: '32px',
    letterSpacing: 0,
    marginBottom: '12px'
  },

  tabColumn:{
    minWidth: 'auto',
    paddingX: 1,
    textTransform: 'none',
    fontSize: '0.9rem',
    fontWeight: '400',
    color: '#757575'
  },

  highlightedTabColumn:{
    minWidth: 'auto',
    paddingX: 1,
    textTransform: 'none',
    fontSize: '0.9rem',
    fontWeight: '700',
    color: '#000'
  },

  contentPage:{
    // padding:'32px',
    backgroundColor: '#F5F3F5',
    color:'black'
  },

  newFolderButton:{
    backgroundColor: '#00445D',
    borderRadius: '5rem',
    textTransform: 'none',
    color: '#fff', // text color
    '&:hover': {
      backgroundColor: '#0d1b5e',
    }
  },

  tabHeader:{
    '& .MuiTabs-indicator': {
      backgroundColor: '#000', 
      height: '4px'
    }
  },

  textField:{
    borderRadius: '10px',
    color: '#666',
    fontSize: '0.9rem',
    paddingTop : 2,
    paddingBottom : 2,
    height: '36px',
    width:'250px'
  },

  searchIcon:{
    fontSize: 20, color: '#888'
  },

  controlContainer:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },


}));



export default function Configurations({currentCompany}) {
  const [tabValue, setTabValue] = React.useState(0);
  const classes = useStyles();

  const history = useHistory();

  const handleHomeClick = () => {
    history.push('/document-suite/configurations');
  };

  


 
  
  return (
    <div className={classes.root}>
    <div style={{borderRadius: '0px'}}>
      <div sx={{ padding: '1rem 0' }}>
        <Button
          onClick={handleHomeClick}
          startIcon={<ArrowBackIcon />}
          className={classes.backButton}
        >
        Back to Configurations
        </Button>
        <Typography 
          variant="h4" 
          className={classes.title}
        >
          STORAGE
        </Typography>
      </div>
    </div>
    <div className={classes.contentPage}>

      <Box mt={2}>
        {/* First row: Tabs */}
        <Box display="flex" alignItems="center">
          <Tabs
            value={tabValue}
            onChange={(e, v) => setTabValue(v)}
            className={classes.tabHeader}
            aria-label="storage tabs"
          >
            <Tab label="Folders" className={tabValue === 0 ? classes.highlightedTabColumn : classes.tabColumn} />
            <Tab label="Fields" className={tabValue === 1 ? classes.highlightedTabColumn : classes.tabColumn} />
            <Tab label="Categories" className={tabValue === 2 ? classes.highlightedTabColumn : classes.tabColumn} />
          </Tabs>
        </Box>
      </Box>

      <Box mt={2}>
        {tabValue === 0 && <Folders currentCompany={currentCompany} />}
        {tabValue === 1 && <Fields currentCompany={currentCompany} />}
        {tabValue === 2 && <Categories currentCompany={currentCompany} />}
      </Box>
    </div>
    </div>
  );
}
